import { deleteUserTimesheets, upsertAbsenceTimesheets } from '../../services/timesheets';
import { absenceBrickId, absenceHoursOnDay } from '../../utils/absences';
import { addDays, dateFromIso, getHolidaysCached, isoStr, isWE } from '../../utils/dates';

export default function absencesTimesheetsHandlers(deps, api) {
  // Crée les entrées de feuille d'heure correspondant à une absence
  // (une par jour ouvré, heures = demi-journées couvertes × 3,5h).
  async function syncAbsenceTimesheets(absence, userId) {
    const rows = [];
    let cur = dateFromIso(absence.debut);
    const end = dateFromIso(absence.fin);
    while (cur <= end) {
      const iso = isoStr(cur);
      if (!isWE(cur) && !getHolidaysCached(cur.getFullYear()).has(iso)) {
        const h = absenceHoursOnDay([absence], iso);
        if (h > 0)
          rows.push({
            user_id: userId,
            dev_id: absence.dev_id,
            date: iso,
            brique_id: absenceBrickId(absence.type),
            heures: h,
            note: 'Absence',
          });
      }
      cur = addDays(cur, 1);
    }
    if (rows.length) await upsertAbsenceTimesheets(rows);
  }

  async function deleteAbsenceTimesheets(absence) {
    const dates = [];
    let cur = dateFromIso(absence.debut);
    const end = dateFromIso(absence.fin);
    while (cur <= end) {
      const iso = isoStr(cur);
      if (!isWE(cur) && !getHolidaysCached(cur.getFullYear()).has(iso)) dates.push(iso);
      cur = addDays(cur, 1);
    }
    if (dates.length) {
      await deleteUserTimesheets(absence, dates);
    }
  }

  return { syncAbsenceTimesheets, deleteAbsenceTimesheets };
}
